import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import Modal from "react-modal";

const CommonModal = ({ isOpen, closeModal, modalExtraStyling, overlayExtraStyling, children }) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        overlayClassName={`modal-overlay ${overlayExtraStyling}`}
        className={`modal ${modalExtraStyling}`}
        ariaHideApp={false}
    >
        {children}
    </Modal>
);

export default CommonModal;
